module.exports = __webpack_public_path__ + "static/media/server-2.3dfa25ee.svg";